import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { AppPreview } from "@/components/AppPreview";

export default function PublicApp() {
  const { slug } = useParams();
  const [app, setApp] = useState(undefined);
  useEffect(() => { api.get(`/public/apps/${slug}`).then((r) => { setApp(r.data); document.title = r.data.name; }).catch(() => setApp(null)); }, [slug]);

  if (app === undefined) return <div className="min-h-screen bg-white" />;
  if (app === null)
    return <div className="min-h-screen grid place-items-center bg-[#0A0D14] text-slate-300" data-testid="public-app-not-found">Esta aplicación no está disponible.</div>;
  return (
    <div className="h-screen flex flex-col">
      <div className="flex-1"><AppPreview html={app.html} dataKey={`public:${slug}`} testId="public-app-iframe" onForm={(f) => api.post(`/public/apps/${slug}/submissions`, { form: f.form, data: f.data }).catch(() => {})} /></div>
      <a href="/" className="text-center text-[11px] py-1 bg-[#0A0D14] text-slate-400 hover:text-cyan-300" data-testid="public-app-badge">Creada con SYNAPSIS</a>
    </div>
  );
}
